import { render } from "./ReportABug.vue?vue&type=template&id=6421e6c2"
import script from "./ReportABug.vue?vue&type=script&lang=js"
export * from "./ReportABug.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__